import { ComponentProps } from 'react';
import { Stack } from '../../../../../design-system/stack/stack';
import { EditEmployeeDetailsFlow } from './edit-employee-details-flow';
import { EmployeeDetailsCard } from './employee-details-card';

type EditEmployeeDetailsDrawerContentProps = {
  employeeDetailsConfig: ComponentProps<typeof EmployeeDetailsCard>;
  bankAccountDetailsConfig: ComponentProps<typeof EditEmployeeDetailsFlow>;
};

export const EditEmployeeDetailsDrawerContent = ({
  employeeDetailsConfig,
  bankAccountDetailsConfig,
}: EditEmployeeDetailsDrawerContentProps) => {
  return (
    <Stack space={4} justify="between" align="stretch" className="h-full">
      <Stack space={5} align="stretch">
        <EmployeeDetailsCard {...employeeDetailsConfig} />

        <h2>Bank account details</h2>
      </Stack>

      <EditEmployeeDetailsFlow {...bankAccountDetailsConfig} />
    </Stack>
  );
};
